import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import PlanPurchaseInfoTab from "./Tabs/PlanPurchaseInfoTab";
import PaymentInfoTab from "./Tabs/PaymentInfoTab";
import userPlanPurchaseApi from "api/userPlanPurchaseApi";
import PremiumBannerTab from "./Tabs/PremiumBannerTab";

export interface Props {
  isOpen: boolean;
  item?: any;
  setLinkImage?: any;
  triggerRefresh?: () => void;
  onClose?: () => void;
}

registerLocale("en", en);
registerLocale("ko", ko);

const UserPlanPurchaseDetail = ({ isOpen, item, triggerRefresh, onClose, setLinkImage }: Props) => {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState("PLAN_PURCHASE_INFO");
  const [dataProfile, setDataProfile] = useState<any>(null);
  
  const tabChange = (tab: any) => {
    if (activeTab !== tab) {
      setActiveTab((_prev) => tab);
    }
  };

  const onCloseClick = () => {
    setActiveTab('PLAN_PURCHASE_INFO');
    onClose && onClose();
  };

  const getDataDetail = async() => {
    if(!item?.id) return;

    try {
      const response: any = await userPlanPurchaseApi.getUserPlanPurchase(item?.id);
      if(response?.data) {
        setDataProfile(response?.data)
      }
    }catch(error) {
      console.log(error)
    }
  }

  const handleUpdateSuccess = async () => {
    getDataDetail();
    triggerRefresh && triggerRefresh();
  }

  const isGuest = () => {
    if(dataProfile?.user_device?.login_type === 'GUEST') return true;

    return false;
  }

  useEffect(() => {
    if(item) {
      getDataDetail()
    }
  }, [item])

  return (
    <Modal isOpen={isOpen} centered={true} size="xl" scrollable={true}>
      <ModalHeader toggle={onCloseClick}>{`${t("Detail User Plan Purchase")} ${item?.jobTitle ? '-'  : ""} ${item?.jobTitle || ""}` }</ModalHeader>
      <ModalBody className="pt-0">
        <div style={{ minHeight: "calc(100dvh - 200px)" }} className="detail-section">
          <Col lg={12}>
            <Card
              id="PLAN_PURCHASE_INFO"
              style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)", borderTop: "unset" }}
            >
              <div
                style={{
                  background: "#f3f6f9",
                  borderTopLeftRadius: "0.6rem",
                  borderTopRightRadius: "0.6rem",
                  position: "sticky",
                  top: "0px",
                  zIndex: 99,
                  borderTop: "1px solid #e9ebec"
                }}
              >
                <div
                  className="d-block"
                  style={{
                    background: "#f3f6f9",
                    borderRadius: "0.6rem",
                    width: "fit-content",
                  }}
                >
                  <Nav
                    tabs
                    className="nav nav-tabs nav-link-none-hover nav-justified"
                  >
                    <NavItem style={{ minWidth: "160px" }}>
                      <NavLink
                        style={{
                          cursor: "pointer",
                          background: `${
                            activeTab === "PLAN_PURCHASE_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "PLAN_PURCHASE_INFO" ? "white" : "unset"
                          }`,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => tabChange("PLAN_PURCHASE_INFO")}
                      >
                        {t("Plan Purchase Info")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ minWidth: "100px" }}>
                      <NavLink
                        style={{
                          cursor: `${
                            isGuest() ? "default" : "pointer"
                          }`,
                          background: `${
                            activeTab === "PAYMENT_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "PAYMENT_INFO" ? "white" : (isGuest() ? "gray" : "unset")
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => {
                          if(isGuest()) return;

                          tabChange("PAYMENT_INFO")
                        }}
                      >
                        {t("Payment Info")}
                      </NavLink>
                    </NavItem>
                    {/* {
                      (dataProfile?.banner && dataProfile?.status === "ACTIVE") && (
                        <NavItem style={{ minWidth: "150px" }}>
                          <NavLink
                            style={{
                              cursor: `${
                                isGuest() ? "default" : "pointer"
                              }`,
                              background: `${
                                activeTab === "PREMIUM_BANNER"
                                  ? "var(--vz-primary)"
                                  : "unset"
                              }`,
                              color: `${
                                activeTab === "PREMIUM_BANNER" ? "white" : (isGuest() ? "gray" : "unset")
                              }`,
                              borderTopLeftRadius: 0,
                              borderTopRightRadius: 0,
                            }}
                            onClick={() => {
                              if(isGuest()) return;

                              tabChange("PREMIUM_BANNER")
                            }}
                          >
                            {t("Premium Banner")}
                          </NavLink>
                        </NavItem>
                      )
                    } */}
                  </Nav>
                </div>
              </div>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="PLAN_PURCHASE_INFO">
                  {activeTab === "PLAN_PURCHASE_INFO" && (
                    <PlanPurchaseInfoTab data={dataProfile} handleUpdateSuccess={handleUpdateSuccess} setLinkImage={setLinkImage} />
                  )}
                </TabPane>
                <TabPane tabId="PAYMENT_INFO">
                  {activeTab === "PAYMENT_INFO" && (
                    <PaymentInfoTab data={dataProfile} handleUpdateSuccess={handleUpdateSuccess} />
                  )}
                </TabPane>

                {/* {
                  (dataProfile?.banner && dataProfile?.status === "ACTIVE") && (
                    <TabPane tabId="PREMIUM_BANNER">
                      {activeTab === "PREMIUM_BANNER" && (
                        <PremiumBannerTab data={dataProfile} handleUpdateSuccess={handleUpdateSuccess} setLinkImage={setLinkImage} />
                      )}
                    </TabPane>
                  )
                } */}
              </TabContent>
            </Card>
          </Col>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UserPlanPurchaseDetail;
